module.exports = __webpack_public_path__ + "static/media/ic_arrow_down.b15e9fd1.svg";